import { render, staticRenderFns } from "./viewPage.vue?vue&type=template&id=020b5800&scoped=true&"
import script from "./viewPage.vue?vue&type=script&lang=js&"
export * from "./viewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b5800",
  null
  
)

export default component.exports